import { render, staticRenderFns } from "./MandatsShow.vue?vue&type=template&id=19a510eb&"
import script from "./MandatsShow.vue?vue&type=script&lang=js&"
export * from "./MandatsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports